// Router.tsx
import { lazy } from "react";

// ============================================
// LANDING
// ============================================
const LandingPage = lazy(() => import("@/app/auth/landing/LandingPage"));
const InitialPage = lazy(() => import("../auth/landing/InitialPage"));

// ============================================
// ONBOARDING
// ============================================
const Connectbankaccount = lazy(
  () =>
    import("@/app/auth/onboarding/connectbankaccount/connectbankaccountpage"),
);
const ExistingAccountpage = lazy(
  () => import("@/app/auth/onboarding/existingAccount/ExistingAccountpage"),
);
const Notifyyoupage = lazy(
  () => import("@/app/auth/onboarding/notifyyou/notifyyoupage"),
);
const ProvideBankDetailspage = lazy(
  () =>
    import("@/app/auth/onboarding/provideBankDetails/ProvideBankDetailspage"),
);
const bankPortal = lazy(
  () => import("@/app/auth/onboarding/bankportal/bankPortal"),
);
const Approvalwaiting = lazy(
  () => import("../auth/onboarding/bankportal/approvalwaiting"),
);
const Cbspermissionpage = lazy(
  () => import("../auth/onboarding/cbspermission/Cbspermissionpage"),
);
const DBExistingAccountpage = lazy(
  () => import("../auth/onboardingDB/dBExistingAccount"),
);
const DBconnectingBankAccount = lazy(
  () => import("../auth/onboardingDB/dBconnectingBankAccount"),
);
const DBBankstatus = lazy(() => import("../auth/onboardingDB/Bankstatus"));
const NewBankAccount = lazy(
  () => import("../auth/onboarding/newBankconnect/newBankconnect"),
);
const Package = lazy(() => import("../auth/onboarding/packageDetails/Package"));
const ApplyBank = lazy(() => import("../auth/onboarding/applybank/applybank"));
const Businessownership = lazy(
  () => import("../auth/onboarding/businessownership/businessownership"),
);
const ExistingAccount = lazy(
  () => import("../auth/onboarding/san/existingaccount/ExistingAccount"),
);
const ProvideBankAccount = lazy(
  () => import("../auth/onboarding/san/existingaccount/ProvideBankAccount"),
);
const Awaitingconfirmation = lazy(
  () => import("../auth/onboarding/san/existingaccount/Awaitingconfirmation"),
);

// Onboarding - KYC
const KycVerificationpage = lazy(
  () => import("@/app/auth/onboarding/kycVerification/kycVerificationpage"),
);
const KycId = lazy(() => import("@/app/auth/onboarding/kycVerification/kycId"));
const KycFace = lazy(
  () => import("../auth/onboarding/kycVerification/kycFace"),
);
const KycUpload = lazy(
  () => import("@/app/auth/onboarding/kycVerification/KycUpload"),
);

// Onboarding - Self KYC
const SelfKYCVerification = lazy(
  () => import("../auth/sanSelfOnboarding/selfKYCVerification"),
);
const SelfKycDocumentUpload = lazy(
  () => import("../auth/sanSelfOnboarding/selfKycDocumentUpload"),
);
const SelffrontendbackUpload = lazy(
  () => import("../auth/sanSelfOnboarding/selffrontendbackUpload"),
);
const SelfKycDocumentsuccessful = lazy(
  () => import("../auth/sanSelfOnboarding/selfKycDocumentsuccessful"),
);
const SelfKycverifiedsuccessful = lazy(
  () => import("../auth/sanSelfOnboarding/selfKycverifiedsuccessful"),
);
const Selfapproval = lazy(
  () => import("../auth/sanSelfOnboarding/selfapproval"),
);
const Selfapprovalwaiting = lazy(
  () => import("../auth/sanSelfOnboarding/selfapprovalwaiting"),
);
const SelfkycverificationFace = lazy(
  () => import("../auth/sanSelfOnboarding/selfkycverificationFace"),
);
const ProfileUpdatedSuccessfully = lazy(
  () => import("../auth/sanSelfOnboarding/profileUpdatedSuccessfully"),
);
const AwaitingBankApproval = lazy(
  () => import("../auth/sanSelfOnboarding/awaitingBankApproval"),
);
const Thankyoupage = lazy(
  () =>
    import("../page/default/admin-menu/myConsent/data-sharing/cbspermission/Thankyoupage"),
);

// ============================================
// DASHBOARD
// ============================================
const Dashboard = lazy(() => import("@/app/page/default/Dashboard/Dashboard"));

// ============================================
// ACCOUNTS
// ============================================
const Accounts = lazy(
  () => import("@/app/page/default/accounts/MyAccountsDetials"),
);
const AccountDetails = lazy(
  () => import("@/app/page/default/accounts/accountdetails/AccountDetials"),
);

// ============================================
// PAYMENTS
// ============================================
const PaymentDashboardPage = lazy(
  () => import("@/app/page/default/payments/paymentDashboard/PaymentDashboard"),
);
const InitiateANewTransferPage = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/InitiateANewTransferPage"),
);
const PaymentHistorypage = lazy(
  () => import("@/app/page/default/payments/paymentHistory/PaymentHistoryPage"),
);
const ShceduledTransfer = lazy(
  () =>
    import("@/app/page/default/payments/scheduledTransfer/ScheduleTransferPage"),
);
const OwnAccountTransferPage = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/ownAccountTransfer/OwnAccountTransferPage"),
);
const DomesticTransferPages = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/domesticTransfer/DomesticTransferPage"),
);
const WithinAccountTransferPage = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/withinAccountTransfer/WithinAccountTransferPage"),
);
const InternationalTransferPage = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/internationalTransfer/InternationalTransferPage"),
);
const LoanPaymnetsPages = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/loanPayments/LoanPaymentPage"),
);
const AaniTransferPages = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/aaniTransfer/AaniTransferPage"),
);

// Payments - Success Pages
const OwnWithinAccountLoanTransferSuccess = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/OwnWithinAccountTransferSuccess"),
);
const DomesticTransferSuccess = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/domesticTransfer/DomesticTransferSuccess"),
);
const InternationalTransferSuccess = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/internationalTransfer/InternationalTransferSuccess"),
);
const AaniTransferSuccess = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/aaniTransfer/AaniSuccessPage"),
);

const CentralBankTransfersScreen = lazy(
  () =>
    import("@/app/page/default/payments/initiateANewTransfer/CentralBankTransferScreen"),
);

// ============================================
// BENEFICIARIES
// ============================================
const Addpage = lazy(
  () =>
    import("@/app/page/default/beneficiaries/addNewBeneficiary/AddNewBeneficiary"),
);
const EditBeneficiaryPage = lazy(
  () =>
    import("@/app/page/default/beneficiaries/editBeneficiary/EditBeneficiary"),
);
const ManagePage = lazy(
  () => import("@/app/page/default/beneficiaries/manageBeneficiary/managepage"),
);
const BeneficiarysuccessPage = lazy(
  () =>
    import("@/app/page/default/beneficiaries/success/BeneficiarysuccessPage"),
);

// ============================================
// PAYER
// ============================================
const AddPayerPage = lazy(
  () => import("@/app/page/default/payer/addPayer/AddPayerPage"),
);
const ManagePayerPage = lazy(
  () => import("@/app/page/default/payer/managePayer/ManagePayerPage"),
);
const EditPayerPage = lazy(
  () => import("@/app/page/default/payer/editPayer/EditPayerPage"),
);

// ============================================
// ADMIN MENU
// ============================================
const AdminMenu = lazy(() => import("@/app/page/default/admin-menu/Adminpage"));
const ManageBankAccounts = lazy(
  () =>
    import("@/app/page/default/admin-menu/managebankaccounts/ManageBankAccounts"),
);
const AuthMatrixPage = lazy(
  () => import("@/app/page/default/admin-menu/auth-matrix/AuthMatrixPage"),
);

// Admin - User Management
const ManageUsers = lazy(
  () => import("@/app/page/default/admin-menu/manageusers/ManageUsers"),
);
const InviteUserPage = lazy(
  () => import("@/app/page/default/admin-menu/invite-users/InviteUserPage"),
);
const EditManageUserPage = lazy(
  () => import("@/app/page/default/admin-menu/manageusers/edit-user/page"),
);
const UserAccessPage = lazy(
  () =>
    import("@/app/page/default/admin-menu/editUserAceessReq/UserAccessRequestPage"),
);
const UserAccessEditPage = lazy(
  () =>
    import("@/app/page/default/admin-menu/user-access-request/edit-user/UserAccessRequestPage"),
);
const UserAccessAcconutPage = lazy(
  () =>
    import("@/app/page/default/admin-menu/common/manage-account-access/ManageAccountAccessPage"),
);
const UsersAccessPage = lazy(
  () =>
    import("@/app/page/default/admin-menu/user-access-request/UsersAccessPage"),
);
const ManageAccountAccessPage = lazy(
  () =>
    import("@/app/page/default/admin-menu/ManageAccountAccess/ManageAccountAccessPage"),
);
const UserManageAccountAccessPage = lazy(
  () =>
    import("@/app/page/default/admin-menu/ManageUserAccountAccess/ManageUserAccountAccessPage"),
);

// Admin - Consent Management
const ServiceInitiationPage = lazy(
  () =>
    import("@/app/page/default/admin-menu/myConsent/service-initiation/ServiceInitiationPage"),
);
const DatashareingPage = lazy(
  () =>
    import("@/app/page/default/admin-menu/myConsent/data-sharing/DatashareingPage"),
);
const ConnectAnotherAccount = lazy(
  () =>
    import("../page/default/admin-menu/myConsent/data-sharing/ConnectAnotherAccount"),
);

// Admin - Third Party
const ManageThirdPartyServicesPage = lazy(
  () =>
    import("@/app/page/default/admin-menu/manage-third-party-services/ThirdPartyServicesPage"),
);

// ============================================
// EIPP / RTP
// ============================================
const Dashboardpage = lazy(
  () => import("@/app/page/default/eipp/dashboard/dashboardpage"),
);
// AddNewInvoice is a named export — wrap it so lazy() receives a default export
const AddNewInvoice = lazy(() =>
  import("../page/default/eipp/add-new-invoice/addNewInvoice").then((m) => ({
    default: m.AddNewInvoice,
  })),
);
const InvoiceSuccessPage = lazy(
  () => import("@/app/page/default/eipp/add-new-invoice/success/SuccessPage"),
);
const RtpDashboardPage = lazy(
  () => import("@/app/page/default/rtp/rtpDashboard/RtpDashboardPage"),
);
const ManageRtpPage = lazy(
  () => import("@/app/page/default/rtp/manageRtpRequests/ManageRtpPage"),
);
const AddNewRtpPage = lazy(
  () => import("@/app/page/default/rtp/request-to-pay/RequestToMoney"),
);
const MyQrCodePage = lazy(
  () => import("@/app/page/default/rtp/my-qr-code/MyQrCodePage"),
);

// ============================================
// BILL PAYMENTS
// ============================================
const ManageBillPage = lazy(
  () => import("@/app/page/default/payments/manageBillPayment/ManageBillPage"),
);
const InitiateNewBillPage = lazy(
  () =>
    import("@/app/page/default/payments/billpayments/initiate-new-bill-payment/InitiateNewBillPage"),
);
const ManagePayeesPage = lazy(
  () =>
    import("@/app/page/default/payments/billpayments/manage-payees/ManagePayeesPage"),
);
const BillPaymentHistory = lazy(
  () =>
    import("@/app/page/default/payments/billpayments/billpaymenthistory/BillPaymentModal"),
);

// ============================================
// BULK UPLOADS
// ============================================
const UploadFile = lazy(
  () => import("@/app/page/default/bulk-uploads/upload-file/UploadFilePage"),
);
const ManageBulkFile = lazy(
  () =>
    import("@/app/page/default/bulk-uploads/manage-bulk-files/ManageBulkFilesPage"),
);
const BulkPaymentReview = lazy(
  () =>
    import("@/app/page/default/bulk-uploads/BulkPaymentReview/BulkPaymentReview"),
);
const BulkUploadIndividual = lazy(
  () =>
    import("@/app/page/default/bulk-uploads/bulk-uploadApprove/BulkUploadIndividualDetails"),
);
const BulkFileUploadBulkUploadApproveTable = lazy(
  () =>
    import("@/app/page/default/bulk-uploads/bulk-uploadApprove/BulkUploadApproveTable"),
);
const BulkFileUploadBulkUploadApproveTablePayroll = lazy(
  () =>
    import("@/app/page/default/bulk-uploads/bulk-uploadApprovePayroll/BulkUploadApproveTablePayroll"),
);
const TppaltareqflowBulk = lazy(
  () => import("@/app/page/default/bulk-uploads/cbuae/Tppaltareqflow"),
);
const BulkCbuaeSuccess = lazy(
  () => import("@/app/page/default/bulk-uploads/cbuae/CbuaeSuccess"),
);
const RetryManageBulkFile = lazy(
  () =>
    import("@/app/page/default/bulk-uploads/RetryManageBulk-files/RetryBulkFilesPage"),
);

// ============================================
// GENERAL PAGES
// ============================================
const ReportsPage = lazy(
  () => import("@/app/page/default/reports/reportsPage"),
);
const SettingsPage = lazy(
  () => import("@/app/page/default/settings/SettingsPage"),
);
const Supportpage = lazy(
  () => import("@/app/page/default/support/supportpage"),
);
const MyProfile = lazy(
  () => import("@/app/page/default/userProfile/myProfile/MyProfile"),
);
const Aboutpage = lazy(() => import("@/app/page/default/aboutUs/aboutpage"));
const ThirdPartyServices = lazy(
  () => import("@/app/page/default/thirdpartyservices/ThirdPartyServices"),
);

// ============================================
// LEGAL
// ============================================
const Termspage = lazy(() => import("@/app/page/default/termsofService/page"));
const PrivacyPage = lazy(() => import("@/app/page/default/privacyPolicy/page"));

// ============================================
// CFO DASHBOARD
// ============================================

const Errorpage = lazy(
  () =>
    import("../page/default/admin-menu/myConsent/data-sharing/cbspermission/Errorpage"),
);
const LoadingPage = lazy(
  () =>
    import("../page/default/admin-menu/myConsent/data-sharing/cbspermission/LoadingPage"),
);
import { ConsentRevoked } from "../auth/landing/consentRevoked";

const ProfileSetup = lazy(
  () => import("../auth/smeOnboarding/profileSetup/profileSetup"),
);
const SetPassword = lazy(
  () => import("../auth/smeOnboarding/profileSetup/setPassword"),
);
const SetMpin = lazy(
  () => import("../auth/smeOnboarding/profileSetup/setMpin"),
);

// ============================================
// CUSTOM / WHITE-LABEL
// ============================================
const santander = lazy(() => import("../page/customfiles/CustomFile/Custom"));
// ============================================
// CUSTOM - Alternative dashborad in FSD Document
// ============================================

// ============================================
// JUNK/TEST PAGES
// ============================================
const DrawerJunkPage = lazy(() => import("@/app/page/default/junk/drawerPage"));
const AssetLibrary = lazy(() => import("@/app/page/default/junk/AssetLibrary"));

const DialogJunkPage = lazy(() => import("@/app/page/default/junk/dialogPage"));

// ============================================
// /MANAGE-THIRD-PARTY-SERVICES/ERP/
// ============================================

import ZohoErp from "@/app/page/default/admin-menu/manage-third-party-services/Erp/ZohoErp";
import Stripe from "@/app/page/default/admin-menu/manage-third-party-services/payment-gateway/Stripe";
import Magnati from "@/app/page/default/admin-menu/manage-third-party-services/payment-gateway/Magnati";
import profileCreated from "../auth/smeOnboarding/profileSetup/profileCreated";
import RegisterFrom from "../auth/smeOnboarding/profileSetup/registerFrom";
import SubscriptionPlan from "../auth/smeOnboarding/profileSetup/subscriptionPlan";
import VerificationProgress from "../auth/smeOnboarding/profileSetup/verificationProgress";
import CompanyAccess from "../auth/smeOnboarding/profileSetup/companyAccess";
import RegisteredSuccessfully from "../page/default/admin-menu/myConsent/data-sharing/cbspermission/registeredSuccessfully";
import EmiratesID from "../auth/smeOnboarding/profileSetup/emiratesID";
import UAEPASSConnect from "../auth/smeOnboarding/profileSetup/UAEPASSConnect";
import Pos from "../page/default/admin-menu/manage-third-party-services/pos-ecom/Pos";
import Ecommerce from "../page/default/admin-menu/manage-third-party-services/pos-ecom/Ecommerce";
import SubmitLoading from "../components/webloading/errorHandling/SubmitLoading";
import RequestSentSuccessfully from "../auth/smeOnboarding/profileSetup/requestSentSuccessfully";
import CompanyIdVerify from "../auth/smeOnboarding/profileSetup/companyIdVerity";
import CfoDashboard from "../page/default/cfoDashboard/cfoDashboard";
import ChatUI from "../page/default/cfoDashboard/ChatUI";
import Receivables from "../page/default/cfoDashboard/receivables/Receivables";
import Payables from "../page/default/cfoDashboard/Payables";
import TreasuryDashboard from "../page/default/alternative-dashboard/TreasuryDashboard";
import ApprovalsWorkspace from "../page/default/alternative-dashboard/ApprovalsWorkspace";
import InsightsCFOCopilot from "../page/default/alternative-dashboard/InsightsCFOCopilot";
import CompactWidgets from "../page/default/alternative-dashboard/CompactWidgets";
import ButtonLibrary from "../page/default/junk/ButtonLibrary";
import AuthGroup from "../page/default/admin-menu/auth-matrix/AuthGroup";
import LoginWizard from "../auth/landing/wizard/LoginWizard";
import SuccessfulPage from "../auth/onboarding/successful/successfulPage";
import { Reconciliation } from "../page/default/Reconciliation/reconciliation";
import { FinancialProfile } from "../auth/smeOnboarding/profileSetup/financialProfile";
import RequestRejected from "../auth/smeOnboarding/profileSetup/requestRejected";
import Requestagain from "../auth/smeOnboarding/profileSetup/requestagain";
const DirectDebitScreen = lazy(
  () => import("../page/default/directDebits/DirectDebitScreen"),
);

const NotificationPage = lazy(
  () => import("../page/default/userProfile/NotificationScreen"),
);

/* ======================================================
                PUBLIC ROUTES
====================================================== */
export const publicRouter = [
  // Auth & Landing
  { id: 1, path: "/", component: LandingPage },

  // Onboarding Flow
  {
    id: 2,
    path: "/onboarding/connectbankaccount",
    component: Connectbankaccount,
  },
  {
    id: 3,
    path: "/onboarding/existingAccount",
    component: ExistingAccountpage,
  },
  { id: 4, path: "/onboarding/cbspermission", component: Cbspermissionpage },
  { id: 5, path: "/onboarding/notifyyou", component: Notifyyoupage },
  {
    id: 6,
    path: "/onboarding/provideBankDetails",
    component: ProvideBankDetailspage,
  },
  { id: 7, path: "/onboarding/bankPortal", component: bankPortal },
  { id: 8, path: "/onboarding/approvalwaiting", component: Approvalwaiting },

  // Onboarding - KYC
  {
    id: 9,
    path: "/onboarding/kycverification",
    component: KycVerificationpage,
  },
  {
    id: 10,
    path: "/onboarding/kycverification/capture/emirates-id",
    component: KycId,
  },
  {
    id: 11,
    path: "/onboarding/kycverification/capture/face",
    component: KycFace,
  },
  { id: 12, path: "/onboarding/kycverification/upload", component: KycUpload },

  // DB Onboarding
  {
    id: 13,
    path: "/onboarding/dBBankConnect",
    component: DBExistingAccountpage,
  },
  {
    id: 14,
    path: "/onboarding/dBConnectingBankAccount",
    component: DBconnectingBankAccount,
  },
  { id: 15, path: "/onboarding/dBDBBankstatus", component: DBBankstatus },
  { id: 16, path: "/onboarding/newBankconnect", component: NewBankAccount },
  { id: 17, path: "/onboarding/packageDetails", component: Package },
  { id: 18, path: "/onboarding/applybank", component: ApplyBank },
  {
    id: 19,
    path: "/onboarding/businessownership",
    component: Businessownership,
  },
  {
    id: 20,
    path: "/onboarding/connectexistingaccount",
    component: ExistingAccount,
  },
  {
    id: 21,
    path: "/onboarding/connectexistingaccount/provideBankAccount",
    component: ProvideBankAccount,
  },
  {
    id: 22,
    path: "/onboarding/awaitingconfirmation",
    component: Awaitingconfirmation,
  },

  // Self KYC Verification
  {
    id: 23,
    path: "/onboarding/selfKYCVerification",
    component: SelfKYCVerification,
  },
  {
    id: 24,
    path: "/onboarding/selfKycDocumentUpload",
    component: SelfKycDocumentUpload,
  },
  {
    id: 25,
    path: "/onboarding/selffrontendbackUpload",
    component: SelffrontendbackUpload,
  },
  {
    id: 26,
    path: "/onboarding/selfKycDocumentsuccessful",
    component: SelfKycDocumentsuccessful,
  },
  {
    id: 27,
    path: "/onboarding/selfKycverifiedsuccessful",
    component: SelfKycverifiedsuccessful,
  },
  { id: 28, path: "/onboarding/selfapproval", component: Selfapproval },
  {
    id: 29,
    path: "/onboarding/selfapprovalwaiting",
    component: Selfapprovalwaiting,
  },
  {
    id: 30,
    path: "/onboarding/selfkycverificationFace",
    component: SelfkycverificationFace,
  },
  {
    id: 31,
    path: "/onboarding/profileUpdatedSuccessfully",
    component: ProfileUpdatedSuccessfully,
  },
  {
    id: 32,
    path: "/onboarding/awaitingBankApproval",
    component: AwaitingBankApproval,
  },
  { id: 33, path: "/onboarding/thankyoupage", component: Thankyoupage },
  {
    id: 34,
    path: "/onboarding/loading",
    component: InitialPage,
  },
  { id: 35, path: "/onboarding/errorpage", component: Errorpage },
  { id: 40, path: "/onboarding/loadingpage", component: LoadingPage },

  // CBP
  { id: 35, path: "/onboarding/connectBank", component: ConnectAnotherAccount },

  // Legal
  { id: 36, path: "/termsofservice", component: Termspage },
  { id: 37, path: "/privacypolicy", component: PrivacyPage },
  {
    id: 38,
    path: "/lfiAuth/:id",
    component: InitialPage,
  },
  {
    id: 39,
    path: "/lfi/error/:id",
    component: InitialPage,
  },
  {
    id: 40,
    path: "/onboarding/loginconsent",
    component: ConsentRevoked,
  },

  { id: 188, path: "/junk/asset-library", component: AssetLibrary },
  { id: 189, path: "/junk/button-library", component: ButtonLibrary },
  {
    id: 41,
    path: "/onboarding/profileSetup",
    component: ProfileSetup,
  },
  {
    id: 42,
    path: "/onboarding/setPassword",
    component: SetPassword,
  },
  {
    id: 43,
    path: "/onboarding/setMpin",
    component: SetMpin,
  },
  {
    id: 43,
    path: "/onboarding/profilecreatedSuccessfully",
    component: profileCreated,
  },

  {
    id: 43,
    path: "/onboarding/registerFrom",
    component: RegisterFrom,
  },
  {
    id: 43,
    path: "/onboarding/subscriptionPlan",
    component: SubscriptionPlan,
  },
  {
    id: 44,
    path: "/onboarding/verificationProgress",
    component: VerificationProgress,
  },
  {
    id: 44,
    path: "/onboarding/requestSentSuccessfully",
    component: RequestSentSuccessfully,
  },
  {
    id: 45,
    path: "/onboarding/companyAccess",
    component: CompanyAccess,
  },
  {
    id: 45,
    path: "/onboarding/companyIdVerify",
    component: CompanyIdVerify,
  },
  {
    id: 46,
    path: "/onboarding/registeredSuccessfully",
    component: RegisteredSuccessfully,
  },
  {
    id: 47,
    path: "/onboarding/emiratesID",
    component: EmiratesID,
  },
  {
    id: 47,
    path: "/onboarding/uaePassConnect",
    component: UAEPASSConnect,
  },
  {
    id: 43,
    path: "/onboarding/submitLoading",
    component: SubmitLoading,
  },
  {
    id: 56,
    path: "/onboarding/successfulnewtobankPage",
    component: SuccessfulPage,
  },
  {
    id: 56,
    path: "/onboarding/financialProfile",
    component: FinancialProfile,
  },
  {
    id: 57,
    path: "/onboarding/requestRejected",
    component: RequestRejected,
  },
  {
    id: 57,
    path: "/onboarding/requestAgain",
    component: Requestagain,
  },
];

/* ======================================================
                PRIVATE ROUTES
====================================================== */
export const privateRouter = [
  // ============================================
  // DASHBOARD
  // ============================================
  { id: 101, path: "/dashboard", component: Dashboard },
  { id: 102, path: "/dashboard/myaccounts", component: Accounts },
  { id: 103, path: "/dashboard/assets", component: Accounts },
  { id: 104, path: "/dashboard/liabilities", component: Accounts },
  {
    id: 105,
    path: "/dashboard/myaccounts/accountdetails",
    component: AccountDetails,
  },

  // ============================================
  // ACCOUNTS
  // ============================================
  { id: 106, path: "/accounts/assets", component: Accounts },
  { id: 107, path: "/accounts/liabilities", component: Accounts },
  {
    id: 108,
    path: "/accounts/assets/accountdetails",
    component: AccountDetails,
  },
  {
    id: 109,
    path: "/accounts/liabilities/accountdetails",
    component: AccountDetails,
  },

  // ============================================
  // PAYMENTS
  // ============================================
  {
    id: 110,
    path: "/payments/paymentDashboard",
    component: PaymentDashboardPage,
  },
  {
    id: 111,
    path: "/payments/initiateANewTransfer",
    component: InitiateANewTransferPage,
  },
  { id: 112, path: "/payments/paymentHistory", component: PaymentHistorypage },
  {
    id: 113,
    path: "/payments/scheduledTransfer",
    component: ShceduledTransfer,
  },

  // Payment Transfer Types
  {
    id: 114,
    path: "/payments/initiate-new-transfer/own-account-transfer",
    component: OwnAccountTransferPage,
  },
  {
    id: 115,
    path: "/payments/initiate-new-transfer/within-account-transfer",
    component: WithinAccountTransferPage,
  },
  {
    id: 116,
    path: "/payments/initiate-new-transfer/domestic-transfer",
    component: DomesticTransferPages,
  },
  {
    id: 117,
    path: "/payments/initiate-new-transfer/international-transfer",
    component: InternationalTransferPage,
  },
  {
    id: 118,
    path: "/payments/initiate-new-transfer/loan-payments",
    component: LoanPaymnetsPages,
  },
  {
    id: 119,
    path: "/payments/initiate-new-transfer/aani-transfer",
    component: AaniTransferPages,
  },

  // Payment Success Pages
  {
    id: 120,
    path: "/payments/initiate-new-transfer/domestic-transfer-success",
    component: DomesticTransferSuccess,
  },
  {
    id: 121,
    path: "/payments/initiate-new-transfer/international-transfer-success",
    component: InternationalTransferSuccess,
  },
  {
    id: 122,
    path: "/payments/initiate-new-transfer/own-account-transfer-success",
    component: OwnWithinAccountLoanTransferSuccess,
  },
  {
    id: 123,
    path: "/payments/initiate-new-transfer/within-account-transfer-success",
    component: OwnWithinAccountLoanTransferSuccess,
  },
  {
    id: 124,
    path: "/payments/initiate-new-transfer/loan-payment-success",
    component: OwnWithinAccountLoanTransferSuccess,
  },
  {
    id: 125,
    path: "/payments/initiate-new-transfer/aani-transfer/success",
    component: AaniTransferSuccess,
  },

  // ============================================
  // BENEFICIARIES
  // ============================================
  { id: 126, path: "/beneficiaries/addNewBeneficiary", component: Addpage },
  {
    id: 127,
    path: "/beneficiaries/editBeneficiary",
    component: EditBeneficiaryPage,
  },
  { id: 128, path: "/beneficiaries/manageBeneficiary", component: ManagePage },
  {
    id: 129,
    path: "/beneficiaries/success",
    component: BeneficiarysuccessPage,
  },

  // ============================================
  // PAYER
  // ============================================
  { id: 130, path: "/payer/addPayer", component: AddPayerPage },
  { id: 131, path: "/payer/managePayer", component: ManagePayerPage },
  { id: 132, path: "/payer/editPayer", component: EditPayerPage },

  // ============================================
  // ADMIN MENU
  // ============================================
  { id: 133, path: "/dashboard/admin-menu", component: AdminMenu },
  {
    id: 134,
    path: "/dashboard/admin-menu/manage-bank-accounts",
    component: ManageBankAccounts,
  },
  {
    id: 135,
    path: "/dashboard/admin-menu/auth-matrix",
    component: AuthMatrixPage,
  },
  {
    id: 136,
    path: "/dashboard/admin-menu/manageaccountaccess",
    component: ManageAccountAccessPage,
  },
  {
    id: 137,
    path: "/dashboard/admin-menu/manage-thirdparty-services",
    component: ManageThirdPartyServicesPage,
  },

  // Admin - User Management
  {
    id: 138,
    path: "/dashboard/admin-menu/manage-users",
    component: ManageUsers,
  },
  {
    id: 139,
    path: "/dashboard/admin-menu/invite-users",
    component: InviteUserPage,
  },
  {
    id: 140,
    path: "/dashboard/admin-menu/edit-user",
    component: EditManageUserPage,
  },
  {
    id: 141,
    path: "/dashboard/admin-menu/manage-users/edit-user",
    component: EditManageUserPage,
  },
  {
    id: 142,
    path: "/dashboard/admin-menu/user-access-request",
    component: UsersAccessPage,
  },
  {
    id: 143,
    path: "/dashboard/admin-menu/common/edit-user",
    component: UserAccessPage,
  },
  {
    id: 144,
    path: "/dashboard/admin-menu/user-access-request/edit-user",
    component: UserAccessPage,
  },
  {
    id: 145,
    path: "/dashboard/admin-menu/common/manage-account-access",
    component: UserAccessAcconutPage,
  },
  {
    id: 146,
    path: "/dashboard/admin-menu/useraccess-request/editUser-AceessReq",
    component: UserAccessEditPage,
  },
  {
    id: 147,
    path: "/dashboard/admin-menu/user-manageaccountaccess",
    component: UserManageAccountAccessPage,
  },

  // Admin - Consent Management
  {
    id: 148,
    path: "/dashboard/admin-menu/myConsent/data-sharing",
    component: DatashareingPage,
  },
  {
    id: 149,
    path: "/dashboard/admin-menu/myConsent/service-initiation",
    component: ServiceInitiationPage,
  },

  // ============================================
  // RTP
  // ============================================
  { id: 150, path: "/rtp/rtpDashboard", component: RtpDashboardPage },
  { id: 151, path: "/rtp/manageRtpRequests", component: ManageRtpPage },
  { id: 152, path: "/rtp/request-to-pay", component: AddNewRtpPage },
  { id: 153, path: "/rtp/requesttopay", component: AddNewRtpPage },
  { id: 154, path: "/rtp/my-qr-code/MyQrCodePage", component: MyQrCodePage },
  { id: 155, path: "/dashboadRTP", component: RtpDashboardPage },
  {
    id: 156,
    path: "/request-to-pay/manage-rtp-requests",
    component: ManageRtpPage,
  },
  {
    id: 157,
    path: "/request-to-pay/request-to-money",
    component: AddNewRtpPage,
  },

  // ============================================
  // EIPP / INVOICE
  // ============================================
  { id: 158, path: "/invoice/invoiceDashboard", component: Dashboardpage },
  { id: 159, path: "/invoice/addNewInvoice", component: AddNewInvoice },
  {
    id: 160,
    path: "/invoice/addNewInvoice/success",
    component: InvoiceSuccessPage,
  },

  // ============================================
  // BULK UPLOADS
  // ============================================
  { id: 161, path: "/bulkuploads/uploadfile", component: UploadFile },
  { id: 162, path: "/bulkuploads/managebulkfile", component: ManageBulkFile },
  {
    id: 163,
    path: "/bulkuploads/managebulkfile/bulkpaymentreview",
    component: BulkPaymentReview,
  },
  {
    id: 164,
    path: "/bulk-uploadApprove/BulkUploadIndividual",
    component: BulkUploadIndividual,
  },
  { id: 165, path: "/upload-file/UploadFilePage", component: UploadFile },
  { id: 166, path: "/bulk-uploads/managebulkfile", component: ManageBulkFile },
  {
    id: 167,
    path: "/bulk-uploads/BulkPaymentReview/BulkPaymentReview",
    component: BulkPaymentReview,
  },
  {
    id: 168,
    path: "/bulk-uploads/bulk-uploadApprove/BulkUploadIndividualDetails",
    component: BulkPaymentReview,
  },
  {
    id: 169,
    path: "/bulk-uploads/bulk-uploadApprove/BulkUploadApproveTable",
    component: BulkFileUploadBulkUploadApproveTable,
  },
  {
    id: 170,
    path: "/bulk-uploads/bulk-uploadApprovePayroll/BulkUploadApproveTablePayroll",
    component: BulkFileUploadBulkUploadApproveTablePayroll,
  },
  {
    id: 171,
    path: "/bulk-uploads/cbuae/Tppaltareqflow",
    component: TppaltareqflowBulk,
  },
  {
    id: 172,
    path: "/bulk-uploads/cbuae/CbuaeSuccess",
    component: BulkCbuaeSuccess,
  },
  {
    id: 173,
    path: "/auth/consent-onboarding",
    component: ConnectAnotherAccount,
  },
  {
    id: 199,
    path: "/bulk-uploads/RetryManageBulk-files/RetryBulkFilesPage",
    component: RetryManageBulkFile,
  },
  {
    id: 200,
    path: "/bulk-uploads/RetryManageBulk-files/RetryPayrollFilesPage",
    component: RetryManageBulkFile,
  },

  // ============================================
  // BILL PAYMENTS
  // ============================================
  {
    id: 174,
    path: "/billpayments/billpaymentDashboard",
    component: ManageBillPage,
  },
  { id: 175, path: "/initiateANewBillPayment", component: InitiateNewBillPage },
  { id: 176, path: "/billpayments/ManagePayees", component: ManagePayeesPage },
  {
    id: 177,
    path: "/billpayments/billpaymenthistory",
    component: BillPaymentHistory,
  },

  // ============================================
  // GENERAL PAGES
  // ============================================
  { id: 178, path: "/reports", component: ReportsPage },
  { id: 179, path: "/settings", component: SettingsPage },
  { id: 180, path: "/support", component: Supportpage },
  { id: 182, path: "/aboutUs", component: Aboutpage },
  { id: 181, path: "/myProfile", component: MyProfile },
  // { id: 182, path: "/contactUs", component: ContactUs },

  {
    id: 183,
    path: "/dashboard/thirdpartyservices",
    component: ThirdPartyServices,
  },

  // ============================================
  // KYC/CAM
  // ============================================
  { id: 184, path: "/cam", component: KycId },

  // ============================================
  // CFO DASHBOARD
  // ============================================
  { id: 185, path: "/CFO/Dashboard", component: CfoDashboard },
  { id: 186, path: "/CFO/genieAI", component: ChatUI },
  { id: 186, path: "/CFO/Receivables", component: Receivables },
  { id: 186, path: "/CFO/Payables", component: Payables },

  // ============================================
  // CUSTOM / WHITE-LABEL
  // ============================================
  { id: 187, path: "/santander", component: santander },

  // ============================================
  // CUSTOM - Alternative dashborad in FSD Document
  // ============================================
  {
    id: 201,
    path: "/alternative-dashboard/TreasuryDashboard",
    component: TreasuryDashboard,
  },
  {
    id: 203,
    path: "/alternative-dashboard/ApprovalsWorkspace",
    component: ApprovalsWorkspace,
  },
  {
    id: 204,
    path: "/alternative-dashboard/InsightsCFOCopilot",
    component: InsightsCFOCopilot,
  },
  {
    id: 205,
    path: "/alternative-dashboard/CompactWidgets",
    component: CompactWidgets,
  },

  // ============================================
  // JUNK/TEST PAGES
  // ============================================
  // { id: 188, path: "/junk", component: JunkPage },
  { id: 189, path: "/junk/drawer", component: DrawerJunkPage },
  { id: 190, path: "/junk/dialog", component: DialogJunkPage },
  {
    id: 191,
    path: "/lfiStatus/:id",
    component: InitialPage,
  },
  {
    id: 192,
    path: "/lfi/error",
    component: InitialPage,
  },
  {
    id: 193,
    path: "/dashboard/admin-menu/manage-thirdparty-services/erp/request-zoho-erp",
    component: ZohoErp,
  },

  {
    id: 194,
    path: "/dashboard/admin-menu/manage-thirdparty-services/payment-gateway/stripe",
    component: Stripe,
  },

  {
    id: 195,
    path: "/dashboard/admin-menu/manage-thirdparty-services/payment-gateway/magnati",
    component: Magnati,
  },
  {
    id: 196,
    path: "/dashboard/admin-menu/manage-thirdparty-services/pos-ecommerce/pos",
    component: Pos,
  },
  {
    id: 197,
    path: "/dashboard/admin-menu/manage-thirdparty-services/payment-gateway/e-commerce",
    component: Ecommerce,
  },
  { id: 198, path: "/direct-debit-dashboard", component: DirectDebitScreen },
  { id: 200, path: "/notification", component: NotificationPage },

  {
    id: 201,
    path: "/dashboard/admin-menu/auth-group",
    component: AuthGroup,
  },

  {
    id: 202,
    path: "/getting-started",
    component: LoginWizard,
  },
  {
    id: 203,
    path: "/cb-own-account-transfer",
    component: CentralBankTransfersScreen,
  },
  {
    id: 204,
    path: "/cb-within-bank-transfer",
    component: CentralBankTransfersScreen,
  },
  {
    id: 205,
    path: "/cb-domestic-transfer",
    component: CentralBankTransfersScreen,
  },
  {
    id: 206,
    path: "/cb-international-transfer",
    component: CentralBankTransfersScreen,
  },
  {
    id: 207,
    path: "/cb-loan-account-transfer",
    component: CentralBankTransfersScreen,
  },

  // ............................................
  {
    id: 208,
    path: "/reconciliation/matched&unMatched",
    component: Reconciliation,
  },
];
